export default function MapLayout({ children }) {
  return (
    <div className="h-full w-full flex flex-col">
      <div className="w-full h-full relative">{children}</div>
    </div>
  );
}
